export function checkMobile() {
  const mobile = (!!document && document.querySelector('html').classList.contains('touchevents')) || (!!window && window.innerWidth < 820);
  const tablet = (!!window && window.innerWidth > 819) && (!!document && document.querySelector('html').classList.contains('touchevents'));
  return mobile && !tablet
}
